import {createApi} from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from '../../utils/customBaseQuery';

export const deviceApi = createApi({
	reducerPath: 'deviceApi',
	baseQuery: customBaseQuery,
	refetchOnFocus: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({

		//POST-создать device
		createDevice: builder.mutation({
			query: (name) => ({
				url: '/create',
				method: 'POST',
				body: {name},
				prefix: 'device',
			}),
		}),

		//GET-получить все device
		allDevices: builder.query({
			query: () => ({
				url: '/all',
				method: 'GET',
				prefix: 'device',
			}),
		}),

		//GET-получить device по id
		getDeviceById: builder.query({
			query: (id) => ({
				url: `/${id}`,
				method: 'GET',
				prefix: 'device',
			}),
		}),

		//DELETE-удалить device по id
		deleteDeviceById: builder.mutation({
			query: (id) => ({
				url: `/${id}`,
				method: 'DELETE',
				prefix: 'device',
			}),
		})
		
	}),
});
export const {
	useCreateDeviceMutation,
	useAllDevicesQuery,
	useGetDeviceByIdQuery,
	useDeleteDeviceByIdMutation
} = deviceApi